import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useModalOpen } from "../../../stores/modalStore";
import useProductStore from "../../../stores/productStore";
import { ROOT_PATH_PREFIX, Z_INDEX_POPUP } from "../../common/const";
import { GlassMagnifier, MagnifierContainer } from "react-image-magnifiers";
import CloseButton from "../../common/navigation/CloseButton";
import { GA_Event } from "../../../api/ga";
import useResizeStore from "../../../stores/resizeStore";

const OpenBoard = (props: JSX.IntrinsicElements["div"]) => {
  //
  const setModalOpen = useModalOpen((state) => state.setIsOpen);
  const containerRef = useRef<HTMLDivElement>(null!);
  const resize = useResizeStore((state) => state.resize);
  // for GAEvent
  const ga_product = useProductStore((state) => state.selectedCategory?.ga_id);

  const openURL =
    useProductStore((state) => state.selectedProduct?.open_url) ??
    "/images/products/refrigerator/p_next3/img_open@2x.png";

  return (
    <Wrapper>
      <Panel
        style={{ width: 1700 * resize.ratio, height: 1028 * resize.ratio }}
      >
        <CloseButton
          style={{
            position: "absolute",
            zIndex: Z_INDEX_POPUP,
            top: "5%",
            right: "4%",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setModalOpen(false);
            GA_Event("lg_home", `${ga_product}_open`, "close");
          }}
        />
        <GlassMagnifier
          style={{ borderRadius: 10 }}
          overflow={true}
          imageSrc={ROOT_PATH_PREFIX + openURL}
          imageAlt="Open Popup"
          magnifierBorderSize={2}
          magnifierSize="40%"
          magnifierBackgroundColor="rgba(0,0,0,1)"
        />
      </Panel>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  z-index: ${Z_INDEX_POPUP};
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  pointer-events: visible;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 640px) {
  }
`;

const Panel = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 1.2em;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);

  & > div {
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    align-items: flex-start;
    justify-content: flex-end;
  }

  & div > button {
    position: relative;
    top: 1%;
    right: 1%;
  }
`;

export default OpenBoard;
